import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormikErrors } from "formik";
import { Col, Input, Label, Row } from "reactstrap";
import ModalConfirm from "./ModalConfirm";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import { toast } from "react-toastify";
import DropdownStatusNew from "./DropdownStatusNew";
import {
  PLAN_FEATURE_KEY_OPTION,
  PLAN_FEATURE_LIMIT_TYPE,
} from "helpers/constans";
import { NumericFormat } from "react-number-format";

interface PlanFeatureArrayProps {
  formik: any;
}

const PARAM_DEFAULT = {
  limitType: "",
  key: "",
  maxUsage: undefined,
  durationDays: undefined,
  id: 1,
};

const PlanFeatureArray = ({ formik = "" }: PlanFeatureArrayProps) => {
  const { t } = useTranslation();
  const [isOpenConfirm, setIsOpenConfirm] = useState<boolean>(false);
  const [indexDelete, setIndexDelete] = useState<any>(null);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [firstChangeAllow, setFirstChangeAllow] = useState<boolean>(false);
  const [durationDaysUserToSet, setDurationDaysUserToSet] = useState<any>([]);
  const [isShowJumpPost, setIsShowJumpPost] = useState(true);

  const onCloseConfirmClick = () => {
    setIsOpenConfirm(false);
    setIndexDelete(null);
    setIsConfirmLoading((_prev) => false);
  };

  const handleAddItem = () => {
    formik.setFieldValue("features", [
      ...formik?.values?.features,
      {
        ...PARAM_DEFAULT,
        id: formik?.values?.features?.length + 1,
        ordering: formik?.values?.features?.length + 1,
      },
    ]);
  };

  const handleRemoveItem = (index: number) => {
    const updatedItems = formik?.values?.features.filter(
      (_: any, i: any) => i !== index
    );
    formik.setFieldValue("features", updatedItems);
  };

  const handleActionDelete = async () => {
    try {
      handleRemoveItem(indexDelete);
      setIsOpenConfirm(false);
      toast(
        `${t("The process has been completed.")}`,
        CONFIG_OPTION_TOAST_NORMAL
      );
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      setIndexDelete(null);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
    setIsConfirmLoading((_prev) => false);
  };

  const isDisableDurationDays = (index: number, item?: any) => {
    return durationDaysUserToSet.includes(index);
  };

  return (
    <React.Fragment>
      <>
        <Col lg={12}>
          <Label htmlFor="titleKoreaInput" className="form-label">
            {t("Plan Feature")} <span className="text-danger"></span>
          </Label>

          <table className="w-100">
            <thead>
              <tr style={{ background: "#EDEDED", height: "37px" }}>
                <th style={{ minWidth: 25, paddingLeft: "5px", }}>{t("No.")}</th>
                <th>{t("Feature key")}</th>
                <th>{t("Limit type")}</th>
                <th>{t("Max usage")}</th>
                <th>{t("Duration days")}</th>
                <th>{t("")}</th>
              </tr>
            </thead>
            <tbody>
              {formik?.values?.features?.map((item: any, index: number) => {
                return (
                  <React.Fragment key={`${item?.id}`}>
                  <tr key={`${item?.id}`}>
                    <td
                      className="my-handle"
                      style={{
                        paddingRight: "10px",
                        paddingLeft: "5px",
                        paddingTop: "10px",
                        paddingBottom: "5px",
                        verticalAlign: "top",
                        width: "50px"
                      }}
                    >
                      {index  + 1}
                      {/* <i className="ri-menu-line"></i> */}
                    </td>
                    <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        verticalAlign: "top",
                        width: "220px",
                      }}
                    >
                      <DropdownStatusNew
                        name="key"
                        dataList={PLAN_FEATURE_KEY_OPTION}
                        placeholder={`${t("Select key")}...`}
                        className="dropdown-status-rounded p-0"
                        classNamePrefix="name-prefix"
                        initialValue={item?.key}
                        optionHide={
                          formik?.values?.features?.map((i: any) =>
                            item?.key !== i?.key ? i?.key : ""
                          ) || []
                        }
                        onChangeSelect={(event: any) =>
                          formik.setFieldValue(
                            `features.${index}.key`,
                            event?.value
                          )
                        }
                        // colors={COLOR_BAR_LIST_OPEN_STATUS}
                      />
                      {
                        item?.key === "JUMP_RANK" && (
                          <div 
                            className="text-primary text-decoration-underline cursor-pointer"
                            onClick={() => setIsShowJumpPost((pre) => !pre)}
                            >
                            {t("Setup Jump Post")} {isShowJumpPost ? <i className="ri-arrow-down-s-line" /> : <i className="ri-arrow-up-s-line" />}
                          </div>
                        )
                      }
                      
                      {formik.touched.features?.[index]?.key &&
                      formik.errors.features &&
                      (formik.errors.features?.[index] as FormikErrors<any>)
                        ?.key ? (
                        <small className="text-danger mt-2">
                          {(formik.errors.features?.[index] as any)?.key}
                        </small>
                      ) : null}
                    </td>
                    <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        verticalAlign: "top",
                        width: "220px",
                      }}
                    >
                      <DropdownStatusNew
                        name="type"
                        dataList={PLAN_FEATURE_LIMIT_TYPE}
                        placeholder={`${t("Select type")}...`}
                        className="dropdown-status-rounded p-0"
                        classNamePrefix="name-prefix"
                        initialValue={item?.limitType}
                        onChangeSelect={(event: any) =>
                          formik.setFieldValue(
                            `features.${index}.limitType`,
                            event?.value
                          )
                        }
                        // colors={COLOR_BAR_LIST_OPEN_STATUS}
                      />

                      {formik.touched.features?.[index]?.limitType &&
                      formik.errors.features &&
                      (formik.errors.features?.[index] as FormikErrors<any>)
                        ?.limitType ? (
                        <small className="text-danger mt-2">
                          {(formik.errors.features?.[index] as any)?.limitType}
                        </small>
                      ) : null}
                    </td>
                    <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        verticalAlign: "top",
                      }}
                    >
                      {
                        item?.limitType !== "UNLIMITED" && (
                          <>
                            <NumericFormat
                              name={`features.${index}.maxUsage`}
                              className="form-control" 
                              value={item?.maxUsage} 
                              placeholder={t("Max usage")}
                              allowLeadingZeros 
                              thousandSeparator="," 
                              allowNegative={false}
                              isAllowed={(values) => {
                                const { formattedValue, floatValue } = values;
                                return formattedValue === "" || (floatValue || 0) <= 9999999999;
                              }}
                              onValueChange={(values: any) => {
                                const {floatValue} = values;
                                if(floatValue < 0) return;

                                formik.setFieldValue(
                                  `features.${index}.maxUsage`,
                                  floatValue
                                )
                              }}
                              disabled={(item?.key === "POST_JOB" && item?.limitType === "QUOTA")}
                            />
                            {formik.touched.features &&
                              formik.errors.features &&
                              (formik.errors.features?.[index] as FormikErrors<any>)
                                ?.maxUsage ? (
                                <small className="text-danger mt-2">
                                  {(formik.errors.features?.[index] as any)?.maxUsage}
                                </small>
                              ) : null}
                          </>
                        )
                      }
                    </td>
                    <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        verticalAlign: "top",
                      }}
                    >
                      {
                        item?.limitType !== "UNLIMITED" && (
                          <>
                            <NumericFormat
                              name={`features.${index}.durationDays`}
                              className="form-control" 
                              value={item?.durationDays} 
                              placeholder={t("Duration days")}
                              allowLeadingZeros 
                              thousandSeparator="," 
                              allowNegative={false}
                              isAllowed={(values) => {
                                const { formattedValue, floatValue } = values;
                                return formattedValue === "" || (floatValue || 0) <= 9999999999;
                              }}
                              onValueChange={(values: any) => {
                                const {floatValue} = values;
                                formik.setFieldValue(
                                  `features.${index}.durationDays`,
                                  floatValue
                                )
                              }}
                              disabled={isDisableDurationDays(index, item) || (firstChangeAllow === false && item?.durationDays === null && item?.key === "POST_JOB" && item?.limitType === "QUOTA")}
                            />
                          
                            {
                              (item?.key === "POST_JOB" && item?.limitType === "QUOTA") && (
                                <div
                                  className="d-flex justify-content-start align-items-center form-check me-3 mt-1 pl-2"
                                  onClick={() => {
                                    formik.setFieldValue(
                                      "gender",
                                      item?.value
                                    );
                                  }}
                                >
                                  <input
                                    className="form-check-input me-2"
                                    type="checkbox"
                                    name="user-to-set"
                                    id={`user-to-set-${index}`}
                                    checked={durationDaysUserToSet.includes(index) || (firstChangeAllow === false && item?.durationDays === null && item?.key === "POST_JOB" && item?.limitType === "QUOTA")}
                                    style={{ minWidth: "16px" }}
                                    onChange={(event) => {
                                      const isChecked = event.target.checked;
                                      setFirstChangeAllow(true)
                                      if (isChecked) {
                                        formik.setFieldValue(`features.${index}.durationDays`, null).then(() => {
                                          setDurationDaysUserToSet((prev: any) => [...prev, index]);
                                        });
                                      } else {
                                        formik.setFieldValue(`features.${index}.durationDays`, item?.durationDays).then(() => {
                                          setDurationDaysUserToSet((prev: any) => prev.filter((i: number) => i !== index));
                                        });
                                      }
                                    }}
                                  />
                                  <label
                                    className="form-check-label position-relative"
                                    htmlFor={`user-to-set-${index}`}
                                  >
                                    {t("Allow user to set")}
                                  </label>
                                </div>
                              )
                            }

                            {formik.touched.features?.[index]?.durationDays &&
                            formik.errors.features &&
                            (formik.errors.features?.[index] as FormikErrors<any>)
                              ?.durationDays ? (
                              <small className="text-danger mt-2">
                                {(formik.errors.features?.[index] as any)?.durationDays}
                              </small>
                            ) : null}
                          </>
                        )
                      }
                    </td>
                    <td>
                      <div
                        className="d-flex"
                        style={{ justifyContent: "center" }}
                      >
                        <div>
                          {
                            <div
                              className="text-danger cursor-pointer"
                              onClick={() => {
                                setIsOpenConfirm(true);
                                setIndexDelete(index);
                              }}
                            >
                              <i className="ri-delete-bin-3-fill align-bottom"></i>
                            </div>
                          }
                        </div>
                      </div>
                    </td>
                  </tr>
                  {
                    (item?.key === "JUMP_RANK" && isShowJumpPost) && (
                      <tr key={"JUMP_RANK"}>
                        <td></td>
                        <td colSpan={4}>
                            <Row>
                              <Col lg={6}>
                                <div className="mb-3">
                                  <Label htmlFor="intervalMinutes" className="form-label">
                                    {t("Interval (minutes)")} <span className="text-danger">*</span>
                                  </Label>

                                  <NumericFormat
                                    name={`features.${index}.extra.intervalMinutes`}
                                    className="form-control" 
                                    value={item?.extra?.intervalMinutes} 
                                    placeholder={t("Interval (minutes)")}
                                    allowLeadingZeros 
                                    thousandSeparator="," 
                                    allowNegative={false}
                                    isAllowed={(values) => {
                                      const { formattedValue, floatValue } = values;
                                      return formattedValue === "" || (floatValue || 0) <= 9999999999;
                                    }}
                                    onValueChange={(values: any) => {
                                      const {floatValue} = values;
                                      if(floatValue < 0) return;

                                      formik.setFieldValue(
                                        `features.${index}.extra.intervalMinutes`,
                                        floatValue
                                      )
                                    }}
                                  />
                                  {//formik.touched.features?.[index]?.intervalMinutes &&
                                    formik.errors.features &&
                                    (formik.errors.features?.[index]?.extra as FormikErrors<any>)
                                      ?.intervalMinutes ? (
                                      <small className="text-danger mt-2">
                                        {(formik.errors.features?.[index] as any)?.extra?.intervalMinutes}
                                      </small>
                                    ) : null}
                                  </div>
                              </Col>
                              <Col lg={6}>
                                <div className="mb-3">
                                  <Label htmlFor="maxUsagePerDay" className="form-label">
                                    {t("Max Jump Per Day")} <span className="text-danger">*</span>
                                  </Label>

                                  <NumericFormat
                                    name={`features.${index}.extra.maxUsagePerDay`}
                                    className="form-control" 
                                    value={item?.extra?.maxUsagePerDay} 
                                    placeholder={t("Max Jump Per Day")}
                                    allowLeadingZeros 
                                    thousandSeparator="," 
                                    allowNegative={false}
                                    isAllowed={(values) => {
                                      const { formattedValue, floatValue } = values;
                                      return formattedValue === "" || (floatValue || 0) <= 9999999999;
                                    }}
                                    onValueChange={(values: any) => {
                                      const {floatValue} = values;
                                      if(floatValue < 0) return;

                                      formik.setFieldValue(
                                        `features.${index}.extra.maxUsagePerDay`,
                                        floatValue
                                      )
                                    }}
                                  />
                                  {formik.touched?.features &&
                                    formik.errors.features &&
                                    (formik.errors.features?.[index]?.extra as FormikErrors<any>)
                                      ?.maxUsagePerDay ? (
                                      <small className="text-danger mt-2">
                                        {(formik.errors.features?.[index] as any)?.extra?.maxUsagePerDay}
                                      </small>
                                    ) : null}
                                  </div>
                              </Col>
                              <Col lg={6}>
                                <div className="mb-3">
                                  <Label htmlFor="actionCost" className="form-label">
                                    {t("Manual Jump - Cost")} <span className="text-danger">*</span>
                                  </Label>

                                  <NumericFormat
                                    name={`features.${index}.extra.actionCost`}
                                    className="form-control" 
                                    value={item?.extra?.actionCost} 
                                    placeholder={t("Manual Jump - Cost")}
                                    allowLeadingZeros 
                                    thousandSeparator="," 
                                    allowNegative={false}
                                    isAllowed={(values) => {
                                      const { formattedValue, floatValue } = values;
                                      return formattedValue === "" || (floatValue || 0) <= 9999999999;
                                    }}
                                    onValueChange={(values: any) => {
                                      const {floatValue} = values;
                                      if(floatValue < 0) return;

                                      formik.setFieldValue(
                                        `features.${index}.extra.actionCost`,
                                        floatValue
                                      )
                                    }}
                                  />
                                  {//formik.touched.features?.[index]?.actionCost &&
                                    formik.errors.features &&
                                    (formik.errors.features?.[index]?.extra as FormikErrors<any>)
                                      ?.actionCost ? (
                                      <small className="text-danger mt-2">
                                        {(formik.errors.features?.[index] as any)?.extra?.actionCost}
                                      </small>
                                    ) : null}
                                  </div>
                              </Col>
                              {/* <Col lg={6}>
                                <div className="mb-3">
                                  <Label htmlFor="extra.autoActionCost" className="form-label">
                                    {t("Auto Jump - Cost")} <span className="text-danger">*</span>
                                  </Label>

                                  <NumericFormat
                                    name={`features.${index}.extra.autoActionCost`}
                                    className="form-control" 
                                    value={item?.extra?.autoActionCost} 
                                    placeholder={t("Auto Jump - Cost")}
                                    allowLeadingZeros 
                                    thousandSeparator="," 
                                    allowNegative={false}
                                    isAllowed={(values) => {
                                      const { formattedValue, floatValue } = values;
                                      return formattedValue === "" || (floatValue || 0) <= 9999999999;
                                    }}
                                    onValueChange={(values: any) => {
                                      const {floatValue} = values;
                                      if(floatValue < 0) return;

                                      formik.setFieldValue(
                                        `features.${index}.extra.autoActionCost`,
                                        floatValue
                                      )
                                    }}
                                  />
                                  {//formik.touched.features?.[index]?.extra?.autoActionCost &&
                                    formik.errors.features &&
                                    (formik.errors.features?.[index]?.extra as FormikErrors<any>)
                                      ?.autoActionCost ? (
                                      <small className="text-danger mt-2">
                                        {(formik.errors.features?.[index] as any)?.extra?.autoActionCost}
                                      </small>
                                    ) : null}
                                  </div>
                              </Col> */}
                            </Row>
                        </td>
                      </tr>
                    )
                  }
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </Col>

        {formik.touched?.features && formik.errors?.features ? (
          <small className="text-danger mt-2">
            {typeof formik.errors?.features === "string" &&
              formik.errors?.features}
          </small>
        ) : null}

        {formik?.values?.features?.length < PLAN_FEATURE_KEY_OPTION?.length && (
          <Col lg={12} className="mb-2">
            <div
              className="text-primary text-center cursor-pointer mt-3 d-flex align-items-center justify-content-center gap-2"
              style={{ fontSize: 30, background: "#0bcee91c" }}
              onClick={handleAddItem}
            >
              + <span style={{ fontSize: 14 }}>{t("Add Feature Key")}</span>
            </div>
          </Col>
        )}
      </>

      <ModalConfirm
        header={t("Delete this features")}
        isOpen={isOpenConfirm}
        isLoading={isConfirmLoading}
        onClose={onCloseConfirmClick}
        onConfirm={handleActionDelete}
      />
    </React.Fragment>
  );
};

export default PlanFeatureArray;
